<template>
  <v-data-table
    :headers="headers"
    :items="prodottiSimili"
    sort-by="_id"
    class="elevation-1"
    dense
    hide-default-footer
  >
    <template v-slot:footer>
      <v-list>
        <v-list-item>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogAdd" max-width="900px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success" small dark class="mb-2 mr-4" v-bind="attrs" v-on="on">
                Aggiungi variante prodotto
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Nuova variante prodotto</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <pBarcode @change="componentValueChange" :item="itemBarcode"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <pMultiselect @change="componentValueChange" :item="itemTaglia"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <pMultiselect @change="componentValueChange" :item="itemColore"/>
                    </v-col>
                  </v-row>
                  <!-- <p class="text-h6 text--primary red--text text--lighten-3">Verificare i valori dei prezzi inseriti automaticamente</p> -->
                  <v-row>  
                    <v-col cols="12" sm="6" md="4">
                      <pTesto @change="componentValueChange" :item="itemListino" :key="updateTrigger"/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <pTesto @change="componentValueChange" :item="itemVendita" :key="updateTrigger"/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <pTesto @change="componentValueChange" :item="itemAcquisto" :key="updateTrigger"/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <pTesto @change="componentValueChange" :item="itemGiacenza" :key="updateTrigger"/>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeAdd">
                  Annulla
                </v-btn>
                <v-btn color="blue darken-1" text @click="saveAdd">
                  Salva
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn color="primary" dark small class="mb-2" @click="creaMovimenti" dense>
            Crea movimenti
          </v-btn>
        </v-list-item>
      </v-list>
    </template>  
    <template v-slot:[`item.quantita`]="{ item }">
      <v-edit-dialog
        :return-value.sync="item.quantita"
        large
        persistent
        cancel-text="Annulla"
        save-text="OK"
        @save="saveD"
        @cancel="cancelD"
        @open="openD"
        @close="closeD"
      >
        <div>{{ item.quantita }}</div>
        <template v-slot:input>
          <div class="mt-4 text-h8">
              Qta movimento
          </div>
          <v-text-field v-model="item.quantita" label="Qta" autofocus :rules="rulesValidationQuantita" single-line></v-text-field>
        </template>
      </v-edit-dialog>
    </template>

    <template v-slot:[`item.valore`]="{ item }">
     <v-edit-dialog
        :return-value.sync="item.valore"
        large
        persistent
        cancel-text="Annulla"
        save-text="OK"
        @save="saveD"
        @cancel="cancelD"
        @open="openD"
        @close="closeD"
      >
        <div>{{ item.valore }}</div>
        <template v-slot:input>
          <div class="mt-4 text-h8">
              Valore movimento
          </div>
          <v-text-field v-model="item.valore" label="Valore" autofocus :rules="rulesValidationQuantita" single-line></v-text-field>
        </template>
      </v-edit-dialog>
    </template>

<!--     <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template> -->
    <template v-slot:no-data>
      Nessun prodotto trovato
    </template>
  </v-data-table>
</template>

<script>
  import * as dot from 'dot-object'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import { validazioni } from '@/mixins/validazioni.js'
  import pTesto from '@/views/drawer/elementi/testo'
  import pMultiselect from '@/views/drawer/elementi/multiselect'
  import pBarcode from '@/views/drawer/elementi/barcode'

  /* eslint-disable */
  export default {
    components: {
      pTesto,
      pMultiselect,
      pBarcode
    },
    mixins: [
      validazioni
    ],
    props: {
      item: Object
      /* barcodeProdotto: String ,
      idProdotto: String, // codice + taglia + colore
      item: Object */
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Codice',
          align: 'start',
          sortable: false,
          value: 'codice',
        },
        { text: 'Descrizione', value: 'descrizione' },
        { text: 'Taglia', value: 'taglia' },
        { text: 'Colore', value: 'colore' },
        { text: 'Quantità', value: 'quantita' },
        { text: 'Valore', value: 'valore' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      prodottiSimili: [],
      dialogAdd: false,
      editedItem: {},
      itemBarcode: null,
      itemTaglia: null,
      itemColore: null,
      itemListino: null,
      itemVendita: null,
      itemAcquisto: null,
      itemGiacenza: null,

      updateTrigger: 0,
      prodottoBase: null
    }),
    async created() {
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
      const articoli = backoffice.articoli
      this.itemBarcode = articoli.find(x => x.model === 'ricercaBarcode') 
      this.itemTaglia = articoli.find(x => x.model === 'varianti.variante1')
      this.itemColore = articoli.find(x => x.model === 'varianti.variante2')
      this.itemListino = articoli.find(x => x.model === 'prezzo.L2.base')
      this.itemVendita = articoli.find(x => x.model === 'prezzo.L1.base')
      this.itemAcquisto = articoli.find(x => x.model === 'magazzino.prezzoAcquisto')
      this.itemGiacenza = articoli.find(x => x.model === 'magazzino.giacenza')
    },
    async mounted() {
      await this.getProdottiSimili()
/*       if (this.item) {
        const barcodeProdotto = this.item.prodotto.barcode
        this.prodottoBase = await prodotti.getDettaglioProdotto(this.item.prodotto.id) 
        const elProdotti = await prodotti.searchProdottiTC(barcodeProdotto)
        this.prodottiSimili = elProdotti.docs.map(x => { return {
          _id: x._id,
          codice: x.codice,
          descrizione: x.descrizione,
          taglia: x.varianti.variante1.descrizione,
          colore: x.varianti.variante2.descrizione,
          quantita: '',
          valore: '',
          acquisto: x.magazzino && x.magazzino.prezzoAcquisto || 0,
          vendita: x.prezzo && x.prezzo.L1 && x.prezzo.L1.base || 0
        }})
      } */
    },
    watch: {
      async dialogAdd (val) {
        if (val) {
          const base = this.item.prodotto
          this.editedItem = this.prodottoBase // await prodotti.getModello()
          // TODO: Fare funzione su 'prodotti.' che ritorna una copia di un prodotto passato come indice, togliendo i campi necessari
          delete this.editedItem._id
          delete this.editedItem._rev
          delete this.editedItem.barcode
          delete this.editedItem.UltimoAcquisto
          this.editedItem.fornitori = []

          this.itemVendita.value = base.prezzo
          this.itemListino.value = base.prezzo2
          this.itemAcquisto.value = base.acquisto
          this.updateTrigger++
        } else {
          this.closeAdd()
        }
      }
    },
    computed: {
      rulesValidationQuantita() {
        let rl = []
        rl.push(this.rules.required)
        rl.push(this.rules.numero)
        return rl
      }
    },
    methods: {
      async getProdottiSimili() {
        if (this.item) {
          const barcodeProdotto = this.item.prodotto.barcode
          this.prodottoBase = await prodotti.getDettaglioProdotto(this.item.prodotto.id) 
          const elProdotti = await prodotti.searchProdottiTC(barcodeProdotto)
          this.prodottiSimili = elProdotti.docs.map(x => { return {
            _id: x._id,
            codice: x.codice,
            descrizione: x.descrizione,
            taglia: x.varianti.variante1.descrizione,
            colore: x.varianti.variante2.descrizione,
            quantita: '',
            valore: '',
            acquisto: x.magazzino && x.magazzino.prezzoAcquisto || 0,
            vendita: x.prezzo && x.prezzo.L1 && x.prezzo.L1.base || 0
          }})
        }
      },
      creaMovimenti() {
        let pr = this.prodottiSimili.filter(x => x.quantita)
        if (pr.length > 0) {
          this.$emit('creaMovimenti', this.item, pr)
        }
      },
      closeAdd() {
        this.dialogAdd = false
      },
      async saveAdd() {
        let prodotto = this.editedItem
        await prodotti.creaProdotto(prodotto)
        await this.getProdottiSimili()
        this.closeAdd()
      },
      componentValueChange(data) {
        const { model, subModel, value, decimals } = data
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.editedItem, tgt)
        this.aggiornaCorrelati(data)
        let a =  this.editedItem
      },
      async aggiornaCorrelati(data) {
        switch (data.model) {
          case 'prezzo.L2.base':
            let valore = isNaN(data.value) ? 0 : parseFloat(data.value)
            this.editedItem.prezzo.L2.base = +valore.toFixed(2)
            break
          case 'prezzo.L1.base':
            valore = isNaN(data.value) ? 0 : parseFloat(data.value)
            this.editedItem.prezzo.L1.base = +valore.toFixed(2)
            break
          case 'magazzino.prezzoAcquisto':
            valore = isNaN(data.value) ? 0 : parseFloat(data.value)
            this.editedItem.magazzino.prezzoAcquisto = +valore.toFixed(2)
            this.editedItem.magazzino.valore = +(this.editedItem.magazzino.giacenza * this.editedItem.magazzino.prezzoAcquisto).toFixed(2)
            break
          case 'magazzino.giacenza':
            valore = isNaN(data.value) ? 0 : parseFloat(data.value)
            this.editedItem.magazzino.giacenza = +valore.toFixed(2)
            this.editedItem.magazzino.valore = +(this.editedItem.magazzino.giacenza * this.editedItem.magazzino.prezzoAcquisto).toFixed(2)
            break
          case 'ricercaBarcode':
            const adesso = new Date()
            let newBarcode = {
              codice: this.editedItem.ricercaBarcode,
              da: adesso,
              attivo: true
            };
            if (!this.editedItem.barcode || this.editedItem.barcode.length === 0) {
              this.editedItem.barcode = []
            } else {
              for (let el of this.editedItem.barcode) {
                if (el.attivo) {
                  el.attivo = false
                  el.a = adesso
                }
              }
            }
            this.$set(this.editedItem.barcode, this.editedItem.barcode.length || 0, newBarcode)
            break;            
          default:
            break
        } 
      },
      saveD () {
      },
      cancelD () {
      },
      openD () {
      },
      closeD () {
      },      
    }
  }
</script>
